import React, { useCallback, useMemo } from "react";
import styled, { css, keyframes } from "styled-components";
import { COLORS } from "styles/colors";

export default function StepBar({
  percent,
  steps,
  backgroundColor,
  animation = true,
}: {
  percent: number;
  steps: number;
  backgroundColor?: string;
  animation?: boolean;
}) {
  // 완료된 스텝 수, 현재 진행 중인 스텝(채워졌다 비워졌다 애니메이션)
  const completedSteps = useCallback(
    (percent: number, steps: number) => Math.floor((percent / 100) * steps),
    []
  );
  const currentPulseStep = useMemo(
    () => (percent: number, steps: number) =>
      percent >= 100 ? -1 : completedSteps(percent, steps),
    [completedSteps]
  );
  return (
    <StepBarStyled.Container>
      {Array.from({ length: steps }, (_, i) => (
        <StepBarStyled.Item
          key={i}
          $filled={i < completedSteps(percent, steps)}
          $pulse={i === currentPulseStep(percent, steps)}
          $backgroundColor={backgroundColor}
          $animation={animation}
        />
      ))}
    </StepBarStyled.Container>
  );
}

const StepBarStyled = {
  // 스텝당 채워졌다 비워졌다 반복 애니메이션용 스텝 바
  Container: styled.div`
    display: flex;
    width: 100%;
    gap: 4px;
    height: 20px;
  `,
  Item: styled.div<{
    $filled?: boolean;
    $pulse?: boolean;
    $backgroundColor?: string;
    $animation?: boolean;
  }>`
    flex: 1;
    height: 100%;
    border-radius: 2px;
    background-color: ${({ theme, $filled, $backgroundColor }) =>
      $filled
        ? $backgroundColor ?? COLORS.BUTTONS2
        : `${theme.COLORS.WHITE}10`};
    ${({ $pulse, $backgroundColor, $animation }) =>
      $animation &&
      $pulse &&
      css`
        background-color: ${$backgroundColor ?? COLORS.BUTTONS2};
        animation: ${stepBarPulse} 1.5s ease-in-out infinite;
      `}
  `,
};
const stepBarPulse = keyframes`
    0%, 100% { opacity: 0.25; }
    50% { opacity: 1; }
`;
